import store from "./store";

export default (to, from, next) => {
  store.dispatch("sessao/pegaSessao").then(() => next());
};
